import {
  Card,
  CardBody,
  CardHeader,
  Text,
  TextVariants,
} from '@patternfly/react-core';
import { CenteredLoadingSpinner } from '@ole-ui/ole-ui-components';
import { observer } from 'mobx-react';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { storesContext } from 'stores';
import useLocalStorageState from '../../hooks/useLocalStorageState';
import { trialSubscriptionEnroll } from '../../services/SubscriptionService';
import { TrialResponseCode, SubscriptionCode } from '../../types';
import './styles.scss';

function TrialEnroll() {
  const { t } = useTranslation();
  const { routerStore, userStore, premiumSessionsStore } =
    useContext(storesContext);
  const [isResponseReceived, setIsResponseReceived] = useState(false);
  const [canShowErrorMessage, setShowErrorMessage] = useState(false);

  const redirectToHome = async () => {
    try {
      await userStore.getActiveSubscription();

      userStore.getEnablements();
      userStore.getCurrentUserGroups();
      userStore.getCurrentUserAvatar();
      userStore.fetchManagedGroups();
      userStore.getUserIdSettings();
      userStore.getUsageSummary();
      premiumSessionsStore.getPremiumSessionContent();
      routerStore.navigate('home');
    } catch (error) {
      console.error(error);
      setShowErrorMessage(true);
    }
  };

  const [isActiveUser, setActiveUser] = useLocalStorageState(
    'trialActiveUser',
    false,
  );

  function actionTrialEnroll(responseData) {
    const {
      status,
      redirect_url: redirectUrl,
      current_subscription: currentSubscription,
      subscription,
    } = responseData || {};

    // user not authenticated or not register with product trial
    if (
      status === TrialResponseCode.NotAuthenticated ||
      status === TrialResponseCode.NotEnrolledToSku
    ) {
      window.location.href = redirectUrl;
    }
    // created trial subscription
    else if (status === TrialResponseCode.SubscriptionCreated) {
      redirectToHome();
    }
    // user has active subscription
    else if (status === TrialResponseCode.ActiveSubscription) {
      if (
        currentSubscription !== SubscriptionCode.RHLSTrial &&
        subscription === SubscriptionCode.RHLSTrial
      ) {
        setActiveUser(!isActiveUser);
      }

      routerStore.navigate('home');
    } else {
      // server error
      setShowErrorMessage(true);
    }
  }

  useEffect(() => {
    try {
      const trialEnrollRequest = async () => {
        const responseData = await trialSubscriptionEnroll();
        setIsResponseReceived(true);
        actionTrialEnroll(responseData);
      };

      trialEnrollRequest();
    } catch (error) {
      console.warn(error);
    }
  }, []);

  if (!isResponseReceived) {
    return (
      <div className="trial-enroll__loading-state">
        <CenteredLoadingSpinner />
      </div>
    );
  }

  if (canShowErrorMessage) {
    return (
      <div className="trial-enroll">
        <div className="trial-enroll__grid">
          <Card className="trial-enroll__card">
            <CardHeader>
              <Text component={TextVariants.h2}>{t('500 ERROR')}</Text>
              <Text component={TextVariants.h3}>
                {t('Internal server error')}
              </Text>
            </CardHeader>
            <CardBody>
              <div>
                <p />
                <p>
                  <Trans>
                    {'<strong>Oops! Something went wrong on our end.</strong>'}
                  </Trans>
                </p>
                <p>
                  {t(
                    'We encountered an unexpected problem while processing your request. Please try again later.',
                  )}
                </p>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    );
  }
}

export default observer(TrialEnroll);
